const ageSegments = [
    { id: '1', label: '< 15 años' },
    { id: '2', label: '15 - 20 años' },
    { id: '3', label: '20 - 35 años' },
    { id: '4', label: '35 - 60 años' },
    { id: '5', label: '> 60 años' }
];

const genders = [
    { id: 'F', label: 'Femenino' },
    { id: 'M', label: 'Masculino' },
    { id: 'O', label: 'Otro Género' }
];

const mapToLabel = (list, id) => {
    const matches = list?.filter(item => item.id === String(id));
    return matches !== undefined && matches !== null && matches.length > 0 ? matches[0]?.label : '';
};

export const useGenders = () => { return { genders: genders, mapGender: (id) => mapToLabel(genders, id) }; };

export const useAgeSegments = () => { return { ageSegments: ageSegments, mapAgeSegment: (id) => mapToLabel(ageSegments, id) }; };